import React, { useState, useEffect } from 'react'
import { string, oneOf, oneOfType, number, bool, func } from 'prop-types'
import FormItemWrapper from 'components/formItemWrapper'
import { connect } from 'formik'
import { Row } from 'components/shared/layout/styles'
import { Label, Error } from '../shared/forms/styles'
import { Input, Container, CharacterCount, Subtext } from './styles'

const DEFAULT_PROPS = {
	name: '',
	type: 'text',
	placeholder: '',
	label: '',
	defaultValue: null,
	disabled: false,
	innerRef: null
}

const TextInput = ({
	name,
	type,
	placeholder,
	label,
	defaultValue,
	subtext,
	formik,
	disabled,
	onBlur = () => {},
	onChange = () => {},
	innerRef,
	...rest
} = DEFAULT_PROPS) => {
	const value = formik.values?.[name]
	const error = formik.touched?.[name] && formik.errors?.[name]
	const [isFocus, setIsFocus] = useState(!!value)

	function onFocus() {
		setIsFocus(true)
	}

	function formikOnBlur(e) {
		formik.handleBlur(e)
		onBlur(e)
		if (value) {
			return
		}
		setIsFocus(false)
	}

	function formikOnChange(target) {
		formik.setFieldValue(name, target.value)
		onChange(target)
	}

	useEffect(() => {
		if (value || defaultValue) {
			setIsFocus(true)
		}
	}, [value, defaultValue])

	return (
		<FormItemWrapper>
			{label && (
				<Label active={isFocus} htmlFor={name}>
					{label}
				</Label>
			)}
			<Container>
				<Input
					name={name}
					placeholder={placeholder}
					type={type}
					onChange={({ target }) => formikOnChange(target)}
					defaultValue={defaultValue}
					value={formik.values[name] || ''}
					onFocus={onFocus}
					onBlur={(e) => formikOnBlur(e)}
					error={error}
					disabled={disabled}
					ref={innerRef}
					{...rest}
				/>
				{error ? (
					''
				) : (
					<Row padding="0.5rem 1rem" justifyContent="flex-end">
						{rest.maxLength && (
							<CharacterCount>
								{(formik.values[name] || '').length} / {rest.maxLength}
							</CharacterCount>
						)}
					</Row>
				)}
				{error ? '' : <Subtext show={subtext}>{subtext}</Subtext>}
				{error ? <Error show={error}>{error}</Error> : ''}
			</Container>
		</FormItemWrapper>
	)
}

TextInput.propTypes = {
	name: string.isRequired,
	type: oneOf(['text', 'password', 'number', 'date']),
	placeholder: string,
	label: string,
	defaultValue: oneOfType([string, number]),
	disabled: bool,
	onBlur: func,
	onChange: func
}

export default connect(TextInput)
